import React from 'react';
import { Container, Typography, Box, Grid, Paper, Divider } from '@mui/material';
import { Analytics, CalendarMonth, CloudSync, AccountBalance } from '@mui/icons-material';

function About() {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          About Stack Track
        </Typography>
        <Typography variant="subtitle1" sx={{ maxWidth: '800px', mx: 'auto', color: 'text.secondary' }}>
          Stack Track is built to give every poker player—from casual enthusiast to seasoned pro—the data-driven edge they need. 
          Our platform centralizes your entire poker journey, offering everything from bankroll management to performance analytics 
          in one intuitive dashboard. We want your focus to stay on the cards, not on the spreadsheets.
        </Typography>
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          What Drives Us
        </Typography>
        <Typography variant="body1" paragraph>
          We believe that informed decisions and clear insights are key to growth. Stack Track was born out of the desire 
          to simplify and elevate the tracking process so you can focus on developing your game and increasing your returns.
        </Typography>
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom>
          Why Stack Track
        </Typography>
        
        <Grid container spacing={4} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: 'background.paper', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <AccountBalance sx={{ mr: 2, color: 'primary.main' }} />
                <Typography variant="h6">Comprehensive Bankroll Oversight</Typography>
              </Box>
              <Typography variant="body2">
                View deposits, withdrawals, and earnings at a glance.
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: 'background.paper', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Analytics sx={{ mr: 2, color: 'primary.main' }} />
                <Typography variant="h6">Advanced Performance Analytics</Typography>
              </Box>
              <Typography variant="body2">
                Analyze win rates and variance to adjust your strategy.
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: 'background.paper', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CalendarMonth sx={{ mr: 2, color: 'primary.main' }} />
                <Typography variant="h6">Real-Time Poker Calendar</Typography>
              </Box>
              <Typography variant="body2">
                Keep up with upcoming tournaments and events without missing a beat.
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 3, height: '100%', bgcolor: 'background.paper', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <CloudSync sx={{ mr: 2, color: 'primary.main' }} />
                <Typography variant="h6">Accessible Anytime</Typography>
              </Box>
              <Typography variant="body2">
                Cloud-based tools sync across all your devices for consistent, on-the-go updates.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 6 }} />

      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body1" paragraph sx={{ maxWidth: '800px', mx: 'auto' }}>
          Our mission is to empower you with concrete statistics and real-time insights so you can continuously refine your strategy. 
          No more guesswork, no more scattered notes—just a clean, powerful hub that grows with your poker experience. 
          Come see how Stack Track can help you gain the clarity you need to move your poker career forward.
        </Typography>
      </Box>
    </Container>
  );
}

export default About; 